module.exports = __webpack_public_path__ + "img/marron-4.ba21c25c.png";